export enum LocalStorageKey {
  AccessToken = 'AccessToken',
  RefreshToken = 'RefreshToken',
}
